// React
import { useRoutes } from "react-router-dom";

import { AuthRouteMiddleware } from "./Middlewares/AuthRoute.middleware";
import { SplashScreenLayout } from "../Components/Layouts/SplashScreen.layout";
import { TwoStepVerifyForm } from "../Pages/Auth/Components/TwoStepVerifyForm.component";
import {
  menuInfoSelector,
  profileInfoSelector,
  useAppSelector,
  useGetAdminInfoQuery,
  useGetMenuInfoQuery,
} from "../States";

import {
  AuthPage,
  PhoneForm,
  VerifyForm,
  BankList,
  CreateBankAccount,
  CreateGateway,
  GatewayList,
  GatewaySetting,
  TicketListPage,
  UserEditPage,
  AddressList,
  CreateAddress,
  Document,
  TransactionList,
  TransactionDescription,
  UserAgentPage,
  DashboardLayout,
  GatewayForm,
  ShaparakRequest,
  ShaparakList,
  ShaparakAcceptedList,
  RequestList,
  ShaparakAcceptedInfo,
  Marketing,
  Wallet,
  WalletTransactionList,
  SubsetTransactionList,
  AdminsActivityPage,
  SandboxTransactinons,
  WithdrawList,
  WithdrawInfo,
  GatewayNotifications,
  UserNotification,
  GatewayAdminList,
  UserList,
  UserTransactionList,
  AdminList,
  UserInfoFormFields,
  AdminForm,
  NewsList,
  NewsForm,
  EventList,
  EventForm,
  PanelMain,
  ServiceList,
  TicketItem,
  UserListInventory,
  PartnerList,
  TicketOperatorListPage,
  TicketConversationPage,
} from ".";

export default function Routes() {
  const token = localStorage.getItem("token");
  const profile = useAppSelector(profileInfoSelector);
  const menuInformation = useAppSelector(menuInfoSelector);

  const { isLoading: loadingAdminInfo } = useGetAdminInfoQuery(undefined, {
    skip: token === null || !!profile || !token,
  });

  const { isLoading: loadingMenuInfo } = useGetMenuInfoQuery(undefined, {
    skip: !!menuInformation || !token,
  });

  const isLoading = loadingAdminInfo && loadingMenuInfo;

  const element = useRoutes([
    {
      path: "/",
      element: <AuthRouteMiddleware />,
      children: [
        {
          path: "auth",
          element: <AuthPage />,
          children: [
            { path: "", element: <PhoneForm /> },
            { path: "verify", element: <VerifyForm /> },
            { path: "two-step-verify", element: <TwoStepVerifyForm /> },
          ],
        },
        {
          path: "/",
          element: <DashboardLayout />,
          children: [
            // { path: "/", element: <DashboardPage /> },
            { path: "/", element: <PanelMain /> },
            // bank section
            {
              path: "banklist",
              element: <BankList />,
              children: [
                { path: ":userId", element: <BankList /> },
                { path: "trash", element: <BankList /> },
                { path: "trash/:userId", element: <BankList /> },
              ],
            },
            {
              path: "bank/add/:userId",
              element: <CreateBankAccount />,
            },
            // gateway section
            {
              path: "gatewaylist",
              element: <GatewayList />,
              children: [
                { path: ":userId", element: <GatewayList /> },
                { path: "trash", element: <GatewayList /> },
                { path: "trash/:userId", element: <GatewayList /> },
              ],
            },
            {
              path: "gateway/sandbox/:gatewayId",
              element: <SandboxTransactinons />,
            },
            {
              path: "gateway/admins/:gatewayId",
              element: <GatewayAdminList />,
            },
            {
              path: "gateway/add/:userId",
              element: <CreateGateway />,
            },
            {
              path: "gatewaysetting/:gatewayId",
              element: <GatewaySetting />,
              children: [
                // gateway setting tabs start
                {
                  path: "",
                  element: <GatewayForm />,
                },
                {
                  path: "new-shaparak-request",
                  element: <ShaparakRequest />,
                },
                {
                  path: "shaparak-list",
                  element: <ShaparakList />,
                },
                {
                  path: "request-list",
                  element: <RequestList />,
                },
                {
                  path: "accepted-shaparak-list",
                  element: <ShaparakAcceptedList />,
                },
                {
                  path: "notifications",
                  element: <GatewayNotifications />,
                },
              ],
            },
            {
              path: "shaparak-accepted-info/:shaparakId",
              element: <ShaparakAcceptedInfo />,
            },
            // Ticket section
            {
              path: "ticketlist",
              element: <TicketListPage />,
              children: [
                { path: ":userId", element: <TicketListPage /> },
                { path: "trash", element: <TicketListPage /> },
              ],
            },
            {
              path: "ticket",
              element: <TicketItem />,
              children: [{ path: ":ticketId", element: <TicketItem /> }],
            },
            // User section
            { path: "user/:userId", element: <UserEditPage /> },
            {
              path: "user-notification/:userId",
              element: <UserNotification />,
            },
            {
              path: "userlist",
              element: <UserList />,
              children: [
                {
                  path: "trash",
                  element: <UserList />,
                },
                {
                  path: "person",
                  element: <UserList />,
                },
                {
                  path: "company",
                  element: <UserList />,
                },
                {
                  path: "pending",
                  element: <UserList />,
                },
              ],
            },
            {
              path: "userlist/inventory",
              element: <UserListInventory />,
            },
            {
              path: "user/add",
              element: <UserInfoFormFields />,
            },
            {
              path: "user/transaction-list/:userId",
              element: <UserTransactionList />,
            },
            // User Agent
            { path: "user-agent/:userId", element: <UserAgentPage /> },
            // address section
            {
              path: "addresslist",
              element: <AddressList />,
              children: [
                { path: ":userId", element: <AddressList /> },
                {
                  path: "trash",
                  element: <AddressList />,
                },
                {
                  path: "trash/:userId",
                  element: <AddressList />,
                },
              ],
            },
            {
              path: "address/add/:userId",
              element: <CreateAddress />,
            },
            // documents section
            {
              path: "documents-status/:userId",
              element: <Document />,
            },
            // transaction section
            {
              path: "transactionlist",
              element: <TransactionList />,
              children: [
                {
                  path: ":userId",
                  element: <TransactionList />,
                },
                {
                  path: "sandbox",
                  element: <TransactionList />,
                },
                {
                  path: "sms",
                  element: <TransactionList />,
                },
                {
                  path: "inquiry",
                  element: <TransactionList />,
                },
                {
                  path: "refund",
                  element: <TransactionList />,
                },
              ],
            },
            {
              path: "Transaction/description/:transactionId",
              element: <TransactionDescription />,
            },
            // marketing section
            {
              path: "marketing/:userId",
              element: <Marketing />,
            },
            {
              path: "turnover/:userId",
              element: <SubsetTransactionList />,
            },
            // wallet section
            { path: "walletlist", element: <Wallet /> },
            { path: "walletlist/:userId", element: <Wallet /> },
            {
              path: "wallet/transaction-list/:walletId",
              element: <WalletTransactionList />,
            },
            {
              path: "wallet/transaction-list/:userId/:walletId",
              element: <WalletTransactionList />,
            },
            // withdraw section
            {
              path: "withdrawlist",
              element: <WithdrawList />,
              children: [{ path: ":gatewayId", element: <WithdrawList /> }],
            },
            {
              path: "withdraw/:withdrawId",
              element: <WithdrawInfo />,
            },
            // Admin section
            {
              path: "adminlist",
              element: <AdminList />,
              children: [
                {
                  path: "trash",
                  element: <AdminList />,
                },
              ],
            },
            { path: "admin/add", element: <AdminForm /> },
            { path: "admins-activities", element: <AdminsActivityPage /> },
            // News section
            {
              path: "newslist",
              element: <NewsList />,
              children: [
                {
                  path: "trash",
                  element: <NewsList />,
                },
              ],
            },
            { path: "news/add", element: <NewsForm /> },
            // Event section
            { path: "eventlist", element: <EventList /> },
            { path: "event/add", element: <EventForm /> },
            {
              path: "eventlist/trash",
              element: <EventList />,
            },
            // Services section
            { path: "servicelist", element: <ServiceList /> },
            // PartnerList section
            {
              path: "partnerlist",
              element: <PartnerList />,
              children: [
                {
                  path: "trash",
                  element: <PartnerList />,
                },
              ],
            },
            // Report section
            {
              path: "report",
              element: null,
              children: [
                // ticket operator
                {
                  path: "ticket-operator",
                  element: <TicketOperatorListPage />,
                  children: [
                    { path: "trash", element: <TicketOperatorListPage /> },
                  ],
                },
                // ticket conversation
                {
                  path: "ticket-conversation",
                  element: <TicketConversationPage />,
                  children: [
                    { path: "trash", element: <TicketConversationPage /> },
                  ],
                },
              ],
            },
          ],
        },
        {
          path: "*",
          element: <>404</>,
        },
      ],
    },
  ]);

  return (
    <>
      {isLoading && <SplashScreenLayout />}
      {element}
    </>
  );
}
